import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const VaultInitialEmptyStateWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 0 16px 20px;
    flex-direction: column;
    align-items: stretch;
    background: #FFFFFF;
    border-radius: 16px;
`;

export const VaultInitialEmptyStateContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    position: relative;
`;

export const VaultInitialEmptyStateVisual = styled.div`
    position: relative;
    width: 64px;
    height: 44px;
    margin-bottom: 4px;
`;

export const VaultInitialEmptyStateAvatar = styled.div`
    position: absolute;
    width: 43px;
    height: 43px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    top: 0.31px;
    left: 0.25px;
    box-shadow: 0px 0px 5.78px 0px rgba(0, 0, 0, 0.25);
`;

export const VaultInitialEmptyStateCards = styled.div`
    position: absolute;
    right: 0;
    top: 46px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    padding: 0 23px;
`;

export const VaultInitialEmptyStateCard = styled.div`
    width: 100%;
    border-radius: 33px;
    height: ${props => props.variant === 'gradient' ? '39px' : props.variant === 'light' ? '38px' : '39px'};
    
    ${props => props.variant === 'light' && `
        background: #F7F8F9;
    `}
    
    ${props => props.variant === 'gradient' && `
        background: linear-gradient(180deg, #F7F8F9 0%, #FFFFFF 100%);
    `}
`;

export const VaultInitialEmptyStateTitle = styled.h2`
    font-family: 'Domine', serif;
    font-weight: 700;
    font-size: 28px;
    line-height: 1.14;
    text-align: center;
    color: ${colors.darkGray1};
    margin: 0 0 4px 0;
`;

export const VaultInitialEmptyStateSubtitle = styled.p`
    font-family: Circular;
    font-weight: 450;
    font-size: 18px;
    line-height: 1.265;
    text-align: center;
    color: ${colors.darkGray1};
    margin-bottom: 0px;
`;